import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import MUITextField, { TextFieldProps as MUITextFieldProps } from '@mui/material/TextField'

import classes from './TextField.scss'

export type TextFieldProps = Omit<MUITextFieldProps, 'value'> & {
  maxLength?: number
  minLength?: number
  renderMinMaxLength?: boolean
  isLoading?: boolean
  onlyDigits?: boolean
  value?: string | string[] | number | number[]
}

export default function TextField({
  helperText,
  maxLength = 0,
  minLength = 0,
  renderMinMaxLength = true,
  InputLabelProps,
  isLoading = false,
  onlyDigits = false,
  onChange,
  slotProps,
  SelectProps,
  inputProps,
  InputProps,
  ...others
}: TextFieldProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const { value, placeholder } = others
  const valueLength = typeof value === 'string' || Array.isArray(value) ? value.length : 0

  const handleChangeOnlyDigits = useCallback((evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange({
      ...evt,
      target: {
        ...evt.target,
        value: evt.target.value.replace(/[^\d.]/g, '')
      }
    })
  }, [onChange])

  return (
    <MUITextField
      {...others}

      onChange={onlyDigits ? handleChangeOnlyDigits : onChange}

      slotProps={{
        inputLabel: {
          ...InputLabelProps,
          classes: {
            ...InputLabelProps?.classes,
            root: classNames(classes.InputLabel, InputLabelProps?.classes?.root),
          },
          shrink: InputLabelProps?.shrink ?? (
            placeholder
              ? undefined
              : !!(value && (valueLength || (value as any).value)) || typeof value === 'number'
          ),
        },

        input: {
          ...InputProps,
          className: classes.root,
        },

        htmlInput: {
          ...inputProps,
          maxLength: maxLength || undefined,
        },

        select: {
          ...SelectProps,
          classes: {
            icon: isLoading ? classes.selectIconLoading : undefined,
          },
        },

        ...slotProps
      }}

      helperText={(helperText || maxLength || minLength) ?
        (
          <span className={classes.helper}>
            {helperText ?
              (
                <span className={classes.helperText}>
                  {helperText}
                </span>
              )
              :
              null
            }
            {(renderMinMaxLength && (maxLength || minLength)) ?
              (
                <span className={classes.minMax}>
                  {maxLength ? <span className={classes.maxlength}>{valueLength}/{maxLength}</span> : undefined}
                  {minLength ? <span className={classes.maxlength}>{valueLength} ({t('min')} {minLength})</span> : undefined}
                </span>
              )
              :
              null
            }
          </span>
        )
        :
        null
      }
    />
  )
}
